import { PaymentOptionPropertiesInterface } from '../../../services/exports/Interfaces';
import PaymentMethodBrandIcons, { getBrandIcon } from './PaymentMethodBrandIcons';
import classnames from 'classnames';
import useAppMethods from '../../../hooks/utility/useAppMethods';
import usePaymentFlow from '../../../hooks/payment/usePaymentFlow';

interface Props extends Partial<PaymentOptionPropertiesInterface> {
  amount?: number;
  hideIcons?: boolean;
  classes?: {
    container?: string;
    icon?: string;
    text?: string;
  };
}

export default function PaymentDetails(props: Props) {
  const { payment_method_id, payment_method_brand, payment_method_details, amount, hideIcons, classes } = props;

  const { formatCurrency } = useAppMethods();
  const { findPaymentMethod } = usePaymentFlow();

  const hasBrandIcon = Boolean(getBrandIcon(payment_method_brand));
  const paymentMethod = findPaymentMethod(payment_method_id);

  return (
    <div className={classnames('flex items-center text-sm', classes?.container)}>
      {!hideIcons && (
        <PaymentMethodBrandIcons
          payment_method_id={payment_method_id}
          payment_method_brand={payment_method_brand}
          className={classes?.icon}
        />
      )}
      <p className={classnames('text-sm', { 'ml-xs': !hideIcons }, classes?.text)}>
        {((!hasBrandIcon && Boolean(paymentMethod)) || hideIcons) && `${paymentMethod.display_name} `}
        {Boolean(payment_method_details) && ` •••• ${payment_method_details}`}
        {Boolean(amount) && ` - ${formatCurrency(amount)}`}
      </p>
    </div>
  );
}
